import { useEffect, useState } from "react";
import { Outlet, NavLink, Link } from "react-router-dom";
import { Home, LineChart, ShoppingBag, Wallet, User, Bell, SendHorizonal } from "lucide-react";
import api from "@/lib/api";

const NAV = [
  { to: "/app", label: "Home", icon: Home, end: true },
  { to: "/app/earnings", label: "Earnings", icon: LineChart },
  { to: "/app/sales", label: "Sales", icon: ShoppingBag },
  { to: "/app/submit", label: "Submit", icon: SendHorizonal },
  { to: "/app/deposit", label: "Deposit", icon: Wallet },
  { to: "/app/profile", label: "Profile", icon: User },
];

export default function AgentLayout() {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    const load = () => api.get("/agent/notifications").then((r) => setUnread(r.data.unread)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("inbox-changed", load);
    return () => { clearInterval(t); window.removeEventListener("inbox-changed", load); };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="w-full max-w-md mx-auto min-h-screen relative">
        <Link to="/app/inbox" className="fixed top-3 right-3 z-50 sm:right-[calc(50%-14rem)] w-10 h-10 rounded-full bg-card/90 backdrop-blur border border-border flex items-center justify-center text-muted-foreground hover:text-primary transition-colors" data-testid="agent-inbox-bell">
          <Bell className="w-5 h-5" />
          {unread > 0 && <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-destructive text-destructive-foreground text-[10px] font-bold flex items-center justify-center" data-testid="agent-inbox-unread">{unread > 99 ? "99+" : unread}</span>}
        </Link>
        <main className="pb-24 px-4 pt-5 fadeup">
          <Outlet />
        </main>

        <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md h-16 border-t border-border bg-card/90 backdrop-blur-xl flex justify-around items-center z-50">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`agent-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg min-w-[48px] transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <n.icon className="w-5 h-5" strokeWidth={isActive ? 2.4 : 1.7} />
                  <span className="text-[10px] font-medium">{n.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
